<template>
	<div>
		<el-row v-if="paySource === 1">
			<el-row justify="center" type="flex">
				<el-col :span="spanWidth">
					<el-card class="u-m-b-10">
						<div slot="header">
							<span class="u-font-weight-bold u-font-16">提交成功</span>
						</div>
						<div>正在获取保险公司系统的支付结果...</div>
						<div class="u-m-b-5 u-m-t-5">
							如果您还未完成支付，请
							<el-button :loading="isPayLoading" type="primary" @click="onPayAgain">继续支付</el-button>
						</div>
						<div>
							如果您已完成支付，请
							<el-button type="success" @click="onToPolicyDetail">查看保单详情</el-button>
						</div>
					</el-card>
					<el-image :preview-src-list="previewList" src="/images/policy_zhi.png"></el-image>
				</el-col>
			</el-row>
		</el-row>
		<el-row v-if="paySource === 2">
			<el-row justify="center" type="flex">
				<el-col :span="spanWidth">
					<!-- 自定义警告提示样式 -->
					<div class="custom-warning-alert">
						<div class="warning-text">{{ refusePrompt }}</div>
					</div>
				</el-col>
			</el-row>
			<el-row justify="center" type="flex">
				<el-col :span="spanWidth">
					<div class="u-font-weight-bold u-font-18" style="margin: 5px 0">
						保费合计：
						<span class="red-bold" style="font-size: 1.26em">{{ totalPrice }}</span>
						元
					</div>
					<div v-for="(itemData, index) in payOfflineAccounts" :key="index" class="bank_content">
						<div class="u-flex u-row-between">
							<div>
								<span class="bank_content_text">用户名</span>
								： {{ itemData.accountName }}
							</div>
							<el-button v-if="index === 0" class="u-m-l-20" type="text" @click="onCopy(payOfflineAccounts)">
								一键复制对公信息
							</el-button>
						</div>
						<div class="u-m-t-5">
							<span class="bank_content_text">开户行</span>
							： {{ itemData.accountBank }}
						</div>
						<div class="u-m-t-5">
							<span class="bank_content_text">账号</span>
							： {{ itemData.account }}
						</div>
					</div>
				</el-col>
			</el-row>
			<el-row justify="center" type="flex">
				<el-col :span="spanWidth">
					<avue-form
						ref="refOfflineForm"
						v-model="formPayOffline"
						:option="optionPayOffline"
						:upload-before="onUploadBefore"
						:upload-error="onUploadError"
						@submit="submitTransferCertificate"></avue-form>
				</el-col>
			</el-row>
			<el-row justify="center" type="flex" v-if="isShowPayHint">
				<el-col :span="spanWidth">
					<el-image :preview-src-list="previewList" src="/images/policy_zhi.png"></el-image>
				</el-col>
			</el-row>
		</el-row>
	</div>
</template>

<script>
import {canPayOffline, payOffline} from '@/views/insuranceCenter/api/insureApiNew'
import {optionPayOffline} from 'meibao-insure/src/option/insureOption'
import {isRenBaoDianti, isSanXingTuanYi} from 'meibao-insure/src/util/productUtil'
import {clearHtml} from 'meibao-insure/src/util/commonUtils'

export default {
	name: 'payResult',
	props: {
		payTypesData: {
			type: Array,
			required: true,
			default: () => {
				return []
			},
		},
		prePayNoticeData: {
			type: Object,
		},
		paySource: Number,
		isPayLoading: Boolean,
		isAdd: Boolean,
		//批增原保单ID
		orderId: String | Number,
		tempOrderId: String | Number,
		insureType: String | Number,
		spanWidth: {
			type: Number,
			default: 14,
		},
		isCloseTag: {
			type: Boolean,
			default: false,
		},
		sourceProductId: String | Number,
		productId: String | Number,
		totalPrice: String | Number,
	},
	data() {
		return {
			optionPayOffline: this.deepClone(optionPayOffline),
			formPayOffline: {},
			payOfflineAccounts: [],
			allowNow: -1,
			refusePrompt: '',
			fileData: '',
			previewList: ['/images/policy_zhi.png'],
			isShowPayHint: false,
			confirm: 'no',
		}
	},
	watch: {
		payTypesData: {
			handler(newVal = []) {
				if (newVal && newVal.length > 0) {
					//查找对公数据
					for (let i = 0; i < newVal.length; i++) {
						let {accountInfo = {}, allowNow = -1, refusePrompt, additionAccountInfos = []} = newVal[i]
						if (!this.validatenull(accountInfo)) {
							this.formPayOffline = accountInfo
							this.allowNow = allowNow
							this.refusePrompt = refusePrompt
							//合并对公账户
							additionAccountInfos.unshift(accountInfo)
						}
						this.payOfflineAccounts = additionAccountInfos
					}
					if (this.paySource === 2) {
						this.confirm = 'no'
						//加提示
						setTimeout(() => {
							this.onSubmitHint()
						}, 600)
					}
				}
			},
			immediate: true,
		},
		tempOrderId: {
			handler(newVal) {
				if (newVal) {
					if (this.$refs.refOfflineForm) {
						this.$refs.refOfflineForm.resetForm()
					}
				}
			},
		},
		insureType: {
			handler(newVal, oldVal) {
				if (newVal && newVal !== oldVal) {
					this.handleOptionPayOffline()
				}
			},
			immediate: true,
		},
	},
	mounted() {
		this.optionPayOffline.labelWidth = '100'
	},
	methods: {
		//处理options
		handleOptionPayOffline() {
			//处理对公数据,三星需要其他参数
			this.optionPayOffline.column.forEach((itemData) => {
				let {prop = ''} = itemData
				itemData.display = false
				if (
					isSanXingTuanYi(this.insureType) &&
					['payAccountName', 'payName', 'payAccountNo', 'payBankName'].includes(prop)
				) {
					itemData.display = true
				} else if (isRenBaoDianti(this.insureType) && ['transNo', 'payMoney', 'payAccountNo'].includes(prop)) {
					itemData.display = true
				} else if (['transferTime', 'certificate', 'example'].includes(prop)) {
					itemData.display = true
				}
			})
			//是否显示提示
			this.isShowPayHint = this.envConfig.isBxIe()
		},

		onPayAgain() {
			this.$emit('onPayAgain')
		},
		onToPolicyDetail() {
			this.$emit('onToPolicyDetail')
		},
		//提示
		onSubmitHint() {
			//只有IE保才加提示
			if (this.envConfig.isBxIe()) {
				this.$alert(
					`1、对公打款需要打到准确支行，如果选不到支行需要填上联行号；<br/>
2、不需要实收的订单不要上传凭证，会触发保司的自动实收；<br/>
3、如果两份订单上传了一个凭证，只需要实收一份订单，则需要及时反馈负责老师对应订单的实收，避免机器人实收错误。<br/><br/>`,
					'提示',
					{
						confirmButtonText: '我知道了',
						dangerouslyUseHTMLString: true,
					},
				)
					.then(() => {})
					.catch(() => {})
			}
		},
		async submitTransferCertificate(form = {}, done) {
			//再次确认是否可以对公支付
			try {
				let queryOffline = {
					pid: this.sourceProductId,
				}
				if (this.productId) {
					queryOffline.npid = this.productId
				}
				if (this.isAdd && this.orderId) {
					//批增需要加ID
					queryOffline.orderId = this.orderId
				}
				//检测是否可以支付
				await canPayOffline(queryOffline, this.insureType)
				//上传
				let {
					transferTime,
					payAccountName = '',
					payName = '',
					payAccountNo = '',
					payBankName = '',
					transNo = '',
					payMoney = '',
				} = form
				let query = {
					payTime: transferTime,
					orderId: this.tempOrderId,
					confirm: this.confirm,
				}
				if (isSanXingTuanYi(this.insureType)) {
					Object.assign(query, {payAccountName, payName, payAccountNo, payBankName})
				}
				//'transNo', 'payMoney', 'payAccountNo'
				if (isRenBaoDianti(this.insureType)) {
					Object.assign(query, {transNo, payMoney, payAccountNo})
				}
				let formData = new FormData()
				formData.append('file', this.fileData)
				//调用上传接口
				let resPayOffline = await payOffline(query, formData)
				let {originCode, data: {notice = ''} = {}} = resPayOffline.data || {}
				// originCode = 201 ,并且 notice 不为空
				if (originCode === '201' && notice) {
					this.$confirm(notice, '提示', {
						confirmButtonText: '识别有误，继续提交',
						cancelButtonText: '返回修改',
						dangerouslyUseHTMLString: true,
						showClose: false,
						closeOnClickModal: false,
					})
						.then(() => {
							this.confirm = 'yes'
							this.$refs.refOfflineForm.submit()
						})
						.catch(() => {})
					return
				}
				this.$alert(
					'转账凭证上传成功！对公实收时效为1-3个小时，请耐心等待。超时先检查账户信息、金额等是否有问题。无问题没实收则反馈工作人员。',
					'提示',
				).then(() => {
					//如果是美的光伏，则关闭当前页面
					if (this.envConfig.isBxMeidiGuangfu()) {
						window.close()
					} else {
						if (this.isCloseTag) {
							this.$router.$avueRouter.closeTag()
						}
						this.$emit('onToPolicyDetail')
					}
				})
			} catch (error) {
				this.$alert(error.message || '上传凭证未知错误', '提示', {
					confirmButtonText: '确定',
				})
					.then(() => {})
					.catch(() => {})
			} finally {
				done()
			}
		},
		onUploadBefore(file, done, loading) {
			this.fileData = file
			done()
			console.log(file, done, loading)
		},
		onUploadError(error = '', column) {
			if (error !== '' && error.includes('文件太大')) {
				error = '上传转账凭证大小不能超过 2MB!'
			}
			this.$message.error(error)
		},
		onCopy(payOfflineAccounts = []) {
			//复制功能
			let tempText = ''
			for (let i = 0; i < payOfflineAccounts.length; i++) {
				let {accountName, accountBank, account} = payOfflineAccounts[i]
				tempText += `账户名：${accountName}\n`
				tempText += `开户行：${accountBank}\n`
				tempText += `账号：${account}\n`
				if (i < payOfflineAccounts.length - 1) {
					tempText += `---------------------\n`
				}
			}
			//复制特约
			if (this.prePayNoticeData) {
				tempText += '\n-----【请仔细阅读以下条款内容】-----\n'
				let {content = '', items = []} = this.prePayNoticeData
				if (content) {
					tempText += `${clearHtml(content)}\n`
				}
				if (items.length > 0) {
					for (let item of items) {
						tempText += `${clearHtml(item)}\n`
					}
				}
			}
			this.$Clipboard({
				text: tempText,
			})
				.then(() => {
					this.$message.success('复制成功')
				})
				.catch(() => {
					this.$message.success('复制失败')
				})
		},
	},
}
</script>

<style lang="scss" scoped>
.bank_content {
	padding: 10px 10px 10px 28px;
	width: 100%;
	border: 1px solid gainsboro;
	border-radius: 8px;
	margin-top: 10px;
	font-size: 14px;
	color: #606266;

	&_text {
		width: 55px;
		display: inline-block;
		text-align: justify;
		text-align-last: justify;
	}
}

::v-deep .el-upload-dragger {
	border: none;
}

::v-deep .el-image {
	border-radius: 6px;
	overflow: hidden;
}

::v-deep .el-card__header {
	padding: 10px 0 10px 16px;
}

.custom-warning-alert {
	width: 100%;
	padding: 8px 16px;
	border-radius: 4px;
	background-color: #fdf6ec;
}

.warning-text {
	font-size: 13px;
	color: #e6a23c;
}
</style>
